type ExtendDurationItem = {
  label: string;
  value: number;
  key: string;
  default?: boolean;
};

export const ExtendDurationItems: ExtendDurationItem[] = [
  {
    label: "{{value}} Minutes",
    value: 5,
    key: "5-minutes",
  },
  {
    label: "{{value}} Minutes",
    value: 10,
    key: "10-minutes",
  },
  {
    label: "{{value}} Minutes",
    value: 15,
    key: "15-minutes",
  },
  {
    label: "{{value}} Minutes",
    value: 20,
    key: "20-minutes",
    default: true,
  },
  {
    label: "{{value}} Minutes",
    value: 30,
    key: "30-minutes",
  },
  {
    label: "{{value}} Hour",
    value: 1,
    key: "1-hours",
  },
  {
    label: "{{value}} Hours",
    value: 2,
    key: "2-hours",
  },
  {
    label: "{{value}} Hours",
    value: 4,
    key: "4-hours",
  },
];
